<template>
  <div class="container">
      <el-tag type="success" size="mini">总数 <el-badge class="mark" :value="imageList.length"/></el-tag>&nbsp;&nbsp;
      <el-tag type="danger" size="mini">漏框 <el-badge class="mark" :value="count[1] ? count[1].length : 0"/></el-tag>&nbsp;&nbsp;
      <el-tag type="success" size="mini">多框
        <el-badge class="mark" :value="count[4] ? count[4].length : 0"/></el-tag>&nbsp;&nbsp;
      <el-button type="primary"  @click="regionFixDone" size="mini">此批图片纠错完毕</el-button>
      <regionMarkTip ref="tip" class="tip-button"></regionMarkTip>
     <el-row :gutter="10" class="box">
      <h3>漏框 <el-badge class="mark" :value="count[1] ? count[1].length : 0"/></h3>
      <regionImageItem @fixButtonClick="(activeImage) => fixButtonClick(activeImage, image)" class="region-img-item"
                       v-for="(image, idx) in count[1]"
                       :regions="image.regions"
                       :image="image.dish_img_url"
                       :key="idx"></regionImageItem>
    </el-row>
     <el-row :gutter="10" class="box">
      <h3>多框 <el-badge class="mark" :value="count[4] ? count[4].length : 0"/></h3>
      <regionImageItem @fixButtonClick="(activeImage) => fixButtonClick(activeImage, image)" class="region-img-item"
                       v-for="(image, idx) in count[4]"
                       :regions="image.regions"
                       :image="image.dish_img_url"
                       :key="idx"></regionImageItem>
    </el-row>
    <el-row :gutter="10" class="box">
      <h3>正确 <el-badge class="mark" :value="count[0] ? count[0].length : 0"/></h3>
      <regionImageItem @fixButtonClick="(activeImage) => fixButtonClick(activeImage, image)" class="region-img-item"
                       v-for="(image, idx) in count[0]"
                       :regions="image.regions"
                       :image="image.dish_img_url"
                       :key="idx"></regionImageItem>
    </el-row>
    <el-dialog
	    v-if="fixDialog"
	    :visible.sync="fixDialog"
	    :show-close="false"
	    :close-on-press-escape="false"
	    :close-on-click-modal="false"
	    width="900px">
      <regionResize :id="activeImage.id" :image="activeImage.dish_img_url" :regions="activeImage.regions"
                    @confirmFixRegion="confirmFixRegion" @cancelDialog="cancelDialog"
                    @delete="deleteImage"></regionResize>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiFixRegions, apiRegionFixDone} from '@/api';
import regionImageItem from './reginImageItem';
import regionResize from './regionResize';
import regionMarkTip from './regionMarkTip';

export default {
  name: '',
  components: {
    regionImageItem,
    regionResize,
    regionMarkTip
  },
  data () {
    return {
      fixDialog: false,
      region_img_info_list: [],
      activeImage: {},
      imageList: []
    };
  },
  mounted () {
    // this.setSubTitle('模型检测');
    // this.getRegionImage();
    this.imageList = this.premarkData;
    // this.$refs['tip'].markTip();
  },
  methods: {
    ...mapMutations([
      'setSubTitle',
      'setActiveTab'
    ]),
    ...mapActions([]),
    cancelDialog () {
      this.fixDialog = false;
    },
    deleteImage (id) {
      console.log(id);
      let idx = this.$_.findIndex(this.imageList, a => a.id === id);
      // console.log(res);
      // this.$set(res, 'isDelete', true);
      this.imageList.splice(idx, 1);
    },
    regionFixDone () {
      this.$confirm('是否所有图框的种类都已标注?', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async() => {
        try {
          let res = await apiRegionFixDone(this.active_label_task_id, this.username);
          // this.setActiveTab('taskLiwst');
          this.$emit('setActiveTab', 'bigImageAdmin');
          this.$message.warning('保存成功');
        } catch (e) {
          // console.log(e);
          this.setActiveTab('taskList');
          this.$message.error('保存失败' + e.message);
        };
      }).catch((e) => {
        this.$message.error('您已取消, 请继续标注');
      });
    },
    async confirmFixRegion ({id, fixedRegions}) {
      let res = this.$_.find(this.imageList, a => a.id === id);
      console.log(res);
      this.$set(res, 'regions', fixedRegions);
      console.log(res);
      try {
        await apiFixRegions({
          id: this.activeImage.id,
          regions: fixedRegions,
          mark_user_name: this.username
        });
        // console.log(res);
        // this.$set(this.activeImage, 'regions', []);
        // this.$set(res, 'regions', fixedRegions);
        this.$message.warning('修改成功');
      } catch (e) {
        console.log(e);
        this.$message.error('修改失败: ' + e.message);
      }
      this.cancelDialog();
    },
    // async getRegionImage () {
    //   const res = await apiGetRegionImages();
    //   this.region_img_info_list = res.region_img_info_list;
    // },
    fixButtonClick (img, activeImage) {
      this.activeImage = {};
      this.fixDialog = true;
      this.activeImage = activeImage;
    }
  },
  computed: {
    ...mapGetters([
      'userinfo',
      'premarkData',
      'active_label_task_id'
    ]),
    count() {
      const imageList = this.imageList.filter(a => !a.isDelete);
      imageList.forEach(a => {
        if (!a.hasOwnProperty('error_reason')) {
          this.$set(a, 'error_reason', 0);
        }
      });
      return this.$_.groupBy(this.imageList, "error_reason");
    },
    username () {
      return this.userinfo().username;
    }
  },
  watch: {
    fixDialog (val, oldVal) {
      if (val === false) {
        this.activeImage = {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
 .container {
	 position: relative;
   padding-left: 10px;
   .tip-button {
     display: inline-block;
   }
	 .header1 {
		 position: relative;
		 left: 500px;
		 top: 0;
		 margin-bottom: 10px;
	 }

	 .region-img-item {
		 display: inline-block;
		 padding: 0 5px;
		 vertical-align: top;
	 }
   .region-wrapper {
     position: absolute;
     left: 0;
     top: 0;
     width: 100%;
     height: 100%;
     .region-item {
       border: 2px solid $primary;
       &.fixed {
         border: 2px solid $success;
       }

       &.active {
         border: 2px solid $danger;
       }
     }
   }
 }
</style>
